// extracted by mini-css-extract-plugin
export default {"block":"UserInfo_block__oFETT","title":"UserInfo_title__26Gua","info":"UserInfo_info__SS-3U"};